import { request } from '@/common/utils/request'

// 首页获取Task相关指标
export function fetchTaskIndex (params) {
  return request.get({
    url: 'crm.efficiency.bdapp.getTaskIndex',
    params
  })
}

// 首页获取Onboarding相关指标
export function fetchOnboardingIndex (params) {
  return request.get({
    url: 'crm.efficiency.bdapp.getOnboardingIndex',
    params
  })
}

// 首页获取engagement相关指标
export function fetchEngagementIndex (params) {
  return request.get({
    url: 'crm.efficiency.bdapp.getEngagementIndex',
    params
  })
}

export function fetchTaskIndexList (params) {
  return request.get({
    url: 'crm.bdapp.efficiency.bdapp.getTaskIndexList',
    params
  })
}
